// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeSandboxOutlinedSvg from "@ant-design/icons-svg/es/asn/CodeSandboxOutlined";
import AntdIcon from '../components/AntdIcon';

var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxOutlinedSvg
  }));
};

CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
export default React.forwardRef(CodeSandboxOutlined);